var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskClient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M6.75 8.25C8.40683 8.25 9.75 6.90686 9.75 5.25C9.75 3.59314 8.40683 2.25 6.75 2.25C5.09314 2.25 3.75 3.59314 3.75 5.25C3.75 6.90686 5.09314 8.25 6.75 8.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C15.9068 11.25 17.25 12.5932 17.25 14.25V15.75H15.75M12 8.1555C13.2939 7.82242 14.25 6.64788 14.25 5.25C14.25 3.85213 13.2939 2.67755 12 2.34451M9.75 5.25C9.75 6.90686 8.40682 8.25 6.75 8.25C5.09315 8.25 3.75 6.90686 3.75 5.25C3.75 3.59315 5.09315 2.25 6.75 2.25C8.40682 2.25 9.75 3.59315 9.75 5.25ZM3.75 11.25H9.75C11.4068 11.25 12.75 12.5932 12.75 14.25V15.75H0.75V14.25C0.75 12.5932 2.09315 11.25 3.75 11.25Z",
    stroke: "#16C098",
    strokeWidth: 1.41,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskClient);
export default __webpack_public_path__ + "static/media/askClient.95e53e671491ab7cd43689a4748c908e.svg";
export { ForwardRef as ReactComponent };